import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setStandards } from "../features/standardsSlice";

const STANDARDS_CACHE_KEY = "standards_cache";
const CACHE_EXPIRY_MS = 60 * 60 * 1000; // 1 小時過期

// API URL 定義在元件外部，避免 useEffect 依賴項變動
const API_BASE_URL = process.env.REACT_APP_API_URL;

const useFetchStandards = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // 優先從 localStorage 讀取快取，實現首次渲染即顯示警戒線
        let shouldFetchFromApi = true;

        try {
            const cached = localStorage.getItem(STANDARDS_CACHE_KEY);
            if (cached) {
                const { data, timestamp } = JSON.parse(cached);
                const isExpired = Date.now() - timestamp >= CACHE_EXPIRY_MS;

                // 快取存在時先載入到 Redux
                if (data) {
                    dispatch(setStandards(data));
                }

                // 如果快取未過期，不需要立即從 API 獲取
                if (!isExpired) {
                    shouldFetchFromApi = false;
                }
            }
        } catch {
            // 快取讀取失敗，繼續從 API 獲取
        }

        const fetchStandards = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/standards`);
                if (!response.ok) {
                    console.error(`HTTP error! status: ${response.status}`);
                    return;
                }
                const data = await response.json();
                dispatch(setStandards(data));

                // 同步更新 localStorage 快取（含時間戳記）
                try {
                    localStorage.setItem(STANDARDS_CACHE_KEY, JSON.stringify({
                        data,
                        timestamp: Date.now()
                    }));
                } catch {
                    // localStorage 寫入失敗，忽略
                }
            } catch (error) {
                console.error("Error fetching standards:", error);
            }
        };

        // 根據快取狀態決定是否立即獲取
        if (shouldFetchFromApi) {
            fetchStandards();
        }

        // 每分鐘調用一次 fetchStandards
        const intervalId = setInterval(fetchStandards, 60000);

        // 清除 interval 當組件卸載時
        return () => clearInterval(intervalId);
    }, [dispatch]);

    return null; // 不需要返回 `standards` 因為已儲存至 Redux
};

export default useFetchStandards;
